/************************************************************************************************************
Author                          : Trizent Technologies Private Limited
Date                            : 
Notes/Remarks                   : 

Organization:  	Trizent Technologies Private Limited.
		Module No. 17, SBC, Thejaswini Building
		Phase 1, Technopark, Thiruvananthapuram - 695581, 
		Kerala, India
 
Copyright 2026 (C) Trizent Technologies Pvt Ltd. (www.trizentinc.com)
All rights reserved.
***************************************************************************************************************/

import { Column } from "../../../../common/commonComponents/mediaPreparationTable";
import { Form } from "react-bootstrap";

export const getSolutionProductMasterColumns = (
    t: any,
    onStatusChange: (id: string, status: string) => void,
    canEdit: boolean
  ): Column[] => [

  {
    header: t("mediaSolutionProductMaster.tableColumns.sl_no"),
    key: "slno",
  },
  {
    header: t("mediaSolutionProductMaster.tableColumns.product_name"),
    key: "product_name",
    render: (row) => (
      <td className="px-6 py-2 whitespace-nowrap">
        <span className="text-[14px] font-medium text-slate-700">
          {row.name}
        </span>
      </td>
    ),
  },
  {
    header: t("mediaSolutionProductMaster.tableColumns.category"),
    key: "category",
    render: (row) => (
      <td className="px-6 py-2 whitespace-nowrap">
        <span className="text-[14px] font-medium text-slate-700">
          {row.category}
        </span>
      </td>
    ),
  },

  {
    header: t("mediaSolutionProductMaster.tableColumns.manufacturer"),
    key: "manufacturer",
    render: (row) => (
      <td className="px-6 py-2 whitespace-nowrap">
        <span className="text-[14px] font-medium text-slate-700">
          {row.mf}
        </span>
      </td>
    ),
  },

  {
    header: t("mediaSolutionProductMaster.tableColumns.catalogNumber"),
    key: "catalog_number",
    render: (row) => (
      <td className="px-6 py-2 whitespace-nowrap">
        <span className="text-[14px] font-medium text-slate-700">
          {row.cat}
        </span>
      </td>
    ),
  },

  {
    header: t("mediaSolutionProductMaster.tableColumns.shelfLife"),
    key: "shelfLife",
    render: (row) => (
      <td className="px-6 py-2">
        <span className="text-[14px] font-medium text-slate-700">
          {row.shelfLife}
        </span>
      </td>
    ),
  },

  {
    header: t("mediaSolutionProductMaster.tableColumns.status"),
    key: "status",
    render: (row: any) => (
      <td className="px-6 py-2">
        <div className="flex items-center gap-2">
        <Form.Check
          type="switch"
          id={`status-${row.id}`}
          className="custom-switch-class"
          checked={row.status?.toLowerCase() === "active"}
          disabled={!canEdit}
          onChange={() => {
            if (canEdit) {
              onStatusChange(row.id, row.status);
            }
          }}
        />
          <span className="text-[14px] font-medium text-slate-700 whitespace-nowrap">
            {row.status?.toLowerCase() === "active"
              ? "Active"
              : "Inactive"}
          </span>
        </div>
      </td>
    ),
  },
];